import { Injectable } from '@angular/core';
import { RowClickedEvent } from '@ag-grid-community/core';
import { BehaviorSubject, EMPTY, Observable, of, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { AutoUnsubscribe } from 'projects/cupcake/src/app/core/auto-unsubscribe';
import { OverviewBaseService } from 'projects/cupcake/src/app/core/overview-base.service';
import { UserInfoService } from 'projects/cupcake/src/app/core/user-info.service';
import {
  RequestProductDto,
  RequestsXatSvc,
} from 'projects/cupcake/src/app/xatena-api';

import { LocalizedDatePipe } from '../../../shared/localized-date.pipe';
import { switchMap, tap } from 'rxjs/operators';
import { LocalizedCurrencyPipe } from '../../../shared/localized-currency.pipe';
import { DemandRequestDetailService } from '../demand-request-detail.service';
import { RequestTypeEnum } from '../../../shared/xatena-api/request-type';

@AutoUnsubscribe()
@Injectable()
export class FormlyRequestProductsService extends OverviewBaseService {
  requestId$ = new BehaviorSubject<number | undefined>(undefined);
  currency$ = new BehaviorSubject<string>('');

  requestTypeId$?: BehaviorSubject<RequestTypeEnum>;

  constructor(
    router: Router,
    userInfoService: UserInfoService,
    translateService: TranslateService,
    localizedDatePipe: LocalizedDatePipe,
    localizedCurrencyPipe: LocalizedCurrencyPipe,
    private requestService: RequestsXatSvc,
    private demandRequestDetailService: DemandRequestDetailService
  ) {
    super(
      router,
      userInfoService,
      translateService,
      localizedDatePipe,
      localizedCurrencyPipe
    );
  }

  query(): Observable<RequestProductDto[]> {
    return this.requestId$.pipe(
      switchMap(id => {
        if (id) return this.requestService.getRequestProducts(id);
        return of([]);
      }),
      tap(t => {
        this.demandRequestDetailService.requestProducts$.next(t);
      })
    );
  }

  rowClicked(event: RowClickedEvent): void {}

  cloneProduct(requestProductId: number): Observable<void> {
    const requestId = this.requestId$.value;
    if (requestId)
      return this.requestService
        .getRequestProduct(requestId, requestProductId)
        .pipe(
          switchMap(m => {
            delete m.id;
            m.requestId = requestId;
            m.title = `${m.title} (Kopie)`;

            return this.requestService.createRequestProduct(requestId, m);
          }),
          tap(t => this.refreshRowDataCache())
        );

    return EMPTY;
  }
}
